import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, Phone, Mail } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0A0F0D] border-t border-gray-800 pt-16 pb-8" data-testid="footer">
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_quick-drive-ch/artifacts/7rt1tcah_0294979F-2CB2-4DE3-95CC-2E7DDD36539B.png" 
                alt="Geneva Rental" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-medium mb-6 text-sm uppercase tracking-wider">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/fleet-rental" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.fleetRental')}
                </Link>
              </li>
              <li>
                <Link to="/long-term" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('nav.longTerm')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('footer.terms', 'Terms & Conditions')}
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-400 hover:text-white text-sm transition-colors">
                  {t('footer.reviews', 'Customer Reviews')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-medium mb-6 text-sm uppercase tracking-wider">
              {t('footer.services')}
            </h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">{t('categories.suv')}</li>
              <li className="text-gray-400 text-sm">{t('categories.citadine')}</li>
              <li className="text-gray-400 text-sm">{t('categories.utilitaire')}</li>
              <li className="text-gray-400 text-sm">{t('categories.premium')}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-medium mb-6 text-sm uppercase tracking-wider">
              {t('footer.contact')}
            </h4>
            <div className="space-y-2 mb-4">
              <p className="text-white text-sm font-medium">Car Maintenance Meyrin Sàrl</p>
              <p className="text-[#4A945D] text-sm font-medium">Geneva Rental</p>
            </div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#4A945D] mt-1 flex-shrink-0" strokeWidth={1.5} />
                <span className="text-gray-400 text-sm">
                  Rue des Lattes 62<br />
                  1217 Meyrin, Switzerland
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#4A945D] flex-shrink-0" strokeWidth={1.5} />
                <a href="tel:+41229809393" className="text-gray-400 hover:text-white text-sm transition-colors">
                  022 980 93 93
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#4A945D] flex-shrink-0" strokeWidth={1.5} />
                <a href="mailto:booking@genevarental.ch" className="text-gray-400 hover:text-white text-sm transition-colors">
                  booking@genevarental.ch
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Geneva Rental. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6">
            <Link to="/terms" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              {t('footer.terms')}
            </Link>
            <Link to="/admin" className="text-gray-600 hover:text-gray-400 text-xs transition-colors">
              •
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
